import React, { useEffect, useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { toArabicWord } from "number-to-arabic-words/dist/index-node.js";

function Receipt({ lang, receiptData, branchData, idx }) {
  const [selectedOption, setSelectedOption] = useState(receiptData.purpose || "");
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  function convertDateFormat(inputDate, local) {
    const dateObject = new Date(inputDate);
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };

    const formattedDate = dateObject.toLocaleDateString(local, options);
    return formattedDate;
  }

  useEffect(() => {
    const modalEl = document.getElementById(`myModal${idx}`);

    const handleCloseModal = () => {
      setSelectedOption("");
    };
    modalEl.addEventListener("hidden.bs.modal", handleCloseModal);

    return () => {
      modalEl.removeEventListener("hidden.bs.modal", handleCloseModal);
    };
  }, [idx]);

  return (
    <>
      <button
        className="btn btn-primary"
        data-bs-toggle="modal"
        data-bs-target={`#myModal${idx}`}
      >
        {lang.receipt}
      </button>
      <div className="modal fade" id={`myModal${idx}`} tabindex="-1">
        <div className="modal-xl modal-dialog">
          <div className="modal-content">
            <div className="modal-body print position-relative">
              <button
                type="button"
                className="close"
                data-bs-toggle="modal"
                data-bs-target={`#myModal${idx}`}
              >
                <i className="fa fa-2x">×</i>
              </button>
              <button
                type="button"
                // onClick={() => toPDF()}
                onClick={handlePrint}
                className="btn btn-primary position-absolute top-0 end-0"
                style={{ margin: "1rem 1rem" }}
              >
                {lang.print_reciept || "Print Receipt"}
              </button>
              <div className="fr2-wrap p-4" dir="rtl">
                {/* Top pill title (no transforms; uses flex so it exports cleanly) */}
                <div className="mb-4" dir="rlt">
                  <div className="mx-1">{branchData?.branch_name}</div>
                  <div className="mx-1">
                    سجل تجاري {branchData?.valid_id_number}
                  </div>
                  <div className="mx-1">
                    رقم الجوال {branchData?.contact_number}
                  </div>
                </div>
                <div className="fr2-title-row mt-4">
                  <div className="fr2-title bg-white">
                    {receiptData?.transaction_type === "investor_deposit" ? "سند قبض" : "سند صرف"}
                  </div>
                </div>

                {/* Rounded sheet */}
                <div className="fr2-sheet">
                  {/* subtle top decorative band to mimic the reference curve */}

                  <div className="container-fluid px-4">
                    {/* Row: date (left) + amount box (right) */}
                    <div className="row mt-3">
                      <div className="col-6 d-flex justify-content-start">
                        <div className="fr2-amount text-center">
                          المبلغ: {receiptData?.amount} ريال{" "}
                        </div>
                      </div>
                      <div className="col-6 d-flex justify-content-end">
                        <div className="fr2-datelist lh-lg">
                          <div>
                            التاريخ:{" "}
                            {convertDateFormat(receiptData?.date, "ar-SA")}
                          </div>
                          <div>
                            الموافق: {convertDateFormat(receiptData?.date)}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Right text block */}
                    <div className="row mt-4">
                      <div className="">
                        <div className="fr2-bodytext">
                          <div className="mb-2">
                            <span className="mx-1"></span>
                            {receiptData?.transaction_type === "investor_deposit"
                              ? "استلمنا من المكرم"
                              : "دفعنا إلى المكرم"}{" "}
                            / {receiptData?.FullName}
                          </div>
                          <div className="mb-2">
                            مبلغ وقدره /{" "}
                            {toArabicWord(receiptData?.amount || 0)} ريال
                          </div>
                          <div className="mb-2">
                            طريقة الدفع:
                            {receiptData?.payment_method}
                          </div>
                          <div className="mb-2">
                            {receiptData.type === "withdraw"
                              ? "وذلك مقابل: "
                              : "وذلك عن: "}
                            <select
                              onChange={(e) =>
                                setSelectedOption(e.target.value)
                              }
                              name=""
                              value={selectedOption}
                              className="receipt-select"

                            >
                              <option value=""></option>
                              {receiptData?.transaction_type === "investor_deposit" ? (
                                <>
                                  <option value="إيداعه جزءا من استثماره">
                                    إيداعه جزءا من استثماره
                                  </option>
                                  <option value="زيادة رأس ماله المستثمر">
                                    زيادة رأس ماله المستثمر
                                  </option>
                                  <option value="مساهمة في استثماره القائم">
                                    مساهمة في استثماره القائم
                                  </option>
                                  <option value="دفعة من حصته الاستثمارية">
                                    دفعة من حصته الاستثمارية
                                  </option>
                                  <option value="شراء بطاقات سوا">شراء بطاقات سوا</option>
                                </>
                              ) : (
                                <>
                                  <option value="سحب جزء من استثماره">
                                    سحب جزء من استثماره
                                  </option>
                                  <option value="استرداد دفعة من رأس ماله المستثمر">
                                    استرداد دفعة من رأس ماله المستثمر
                                  </option>
                                  <option value="استلامه جزء من حقوقه الاستثمارية">
                                    استلامه جزء من حقوقه الاستثمارية
                                  </option>
                                  <option value="سحب دفعة من رصيده الاستثماري">
                                    سحب دفعة من رصيده الاستثماري
                                  </option>
                                </>
                              )}
                            </select>{" "}
                            لدى {branchData?.branch_name}
                            {/* {contractData?.description || ""} */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row mt-5 pt-3">
                      <div className="col-6">
                        <div className="fw-semibold">توقيع المستلم</div>
                      </div>
                      <div className="col-6">
                        <div className="fw-semibold">الختم</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-none">
                <div className="fr2-wrap p-4" dir="rtl" ref={componentRef}>
                  {/* Top pill title (no transforms; uses flex so it exports cleanly) */}
                  <div className="mb-4" dir="rlt">
                    <div className="mx-1">{branchData?.branch_name}</div>
                    <div className="mx-1">
                      سجل تجاري {branchData?.valid_id_number}
                    </div>
                    <div className="mx-1">
                      رقم الجوال {branchData?.contact_number}
                    </div>
                  </div>
                  <div className="fr2-title-row mt-4">
                    <div className="fr2-title bg-white">
                      {receiptData?.transaction_type === "investor_deposit" ? "سند قبض" : "سند صرف"}
                    </div>
                  </div>

                  {/* Rounded sheet */}
                  <div className="fr2-sheet">
                    {/* subtle top decorative band to mimic the reference curve */}

                    <div className="container-fluid px-4">
                      {/* Row: date (left) + amount box (right) */}
                      <div className="row mt-3">
                        <div className="col-6 d-flex justify-content-start">
                          <div className="fr2-amount text-center">
                            المبلغ رقمياً ( {receiptData?.amount} ){" "}
                          </div>
                        </div>
                        <div className="col-6 d-flex justify-content-end">
                          <div className="fr2-datelist lh-lg">
                            <div>
                              التاريخ:{" "}
                              {convertDateFormat(receiptData?.date, "ar-SA")}
                            </div>
                            <div>
                              الموافق: {convertDateFormat(receiptData?.date)}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right text block */}
                      <div className="row mt-4">
                        <div className="">
                          <div className="fr2-bodytext">
                            <div className="mb-2">
                              <span className="mx-1"></span>
                              {receiptData?.type === "deposit"
                                ? "استلمنا من المكرم"
                                : "دفعنا إلى المكرم"}{" "}
                              / {receiptData?.FullName}
                            </div>
                            <div className="mb-2">
                              مبلغ وقدره / المبلغ كتابياً /{" "}
                              {receiptData?.amount} /{" "}
                              {toArabicWord(receiptData?.amount || 0)}
                            </div>
                            <div className="mb-2">
                              طريقة الدفع:
                              {receiptData?.payment_method}
                            </div>
                            <div className="mb-2">
                              وذلك عن:{" "}
                              {receiptData.type === "withdraw" && "وذلك مقابل"}{" "}
                              <span
                                style={{
                                  color: "red",
                                }}
                              >
                                {" "}
                                {selectedOption}{" "}
                              </span>
                              لدى {branchData?.branch_name}
                              {/* {contractData?.description || ""} */}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row mt-5 pt-3">
                        <div className="col-6">
                          <div className="fw-semibold">توقيع المستلم</div>
                        </div>
                        <div className="col-6">
                          <div className="fw-semibold">الختم</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Receipt;
